import Select from '@/components/Select.jsx';
import isCompanyRegionSelectionEnabled from '@/lib/isCompanyRegionSelectionEnabled.js';
import { companyRegionOptions } from '@/schema/companyRegionOptions.js';

const CompanyRegionSelect = ({ value, onChange }) => {
  if (!isCompanyRegionSelectionEnabled()) {
    return null;
  }

  const selectedOption = companyRegionOptions.find((option) => option.value === value);

  return <Select className="company-region-select" label="Region" description="Choose the region assigned to this organization." options={companyRegionOptions} value={selectedOption} onChange={(option) => onChange(option.value)} useSearch={false} showReload={false} />;
};

export default CompanyRegionSelect;
